import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import QUERY, {
	type GlobalProductsSettingsSidebarQuery,
} from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-products/src/ui/__generated__/GlobalProductsSettingsSidebarQuery.graphql';

const RESOURCE_TYPE_GLOBAL_PRODUCTS_SETTINGS_SIDEBAR = 'GLOBAL_PRODUCTS_SETTINGS_SIDEBAR';

export const nav4SidebarGlobalProductsSettingsResource: RouteResource<
	PreloadedQuery<GlobalProductsSettingsSidebarQuery>
> = createRelayResource<GlobalProductsSettingsSidebarQuery>({
	type: RESOURCE_TYPE_GLOBAL_PRODUCTS_SETTINGS_SIDEBAR,
	getQuery: (_, { tenantContext: { cloudId, appEditions, isAdmin } }) => ({
		parameters: QUERY,
		variables: {
			cloudId,
			// We can skip the permission check when:
			// 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
			// 2. Upsell is enabled (because upsell is only available to admins), or
			// 3. The main custom onboarding hub gate is disabled (because the custom onboarding feature won't be visible to anyone), or
			// 4. The delegated admin gate is disabled (because only admins would be able to view the feature)
			skipDelegatedAdminCheck:
				isAdmin ||
				(appEditions?.software !== 'PREMIUM_EDITION' &&
					fg('restrict-custom-onboarding-to-premium-tier')) ||
				!fg('jira-onboarding-hub-gate') ||
				!fg('jira-delegated-custom-onboarding'),
		},
		options: { fetchPolicy: 'store-and-network' as const },
	}),
	captureErrors: true,
	isCritical: true,
});
